// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d8d40202","453":"bd27dc7a","732":"8b055485","977":"992ab06a"}[chunkId] + ".chunk.js";
};